module.exports = __webpack_public_path__ + "img/zhijvyun3.36a85f82.png";